module.exports = __webpack_public_path__ + "static/img/tu2-m@2x.256f081d.png";